import {useParams} from '@aboutyou/router';
import {getEntityIdFromRouteParam} from '@aboutyou/utils';

export const useCustomPageId = (): number | undefined => {
  const {pageId} = useParams<{pageId?: string}>();
  const customPageId = getEntityIdFromRouteParam(pageId);

  return customPageId ? Number(customPageId) : undefined;
};
